module.exports = __webpack_public_path__ + "img/Vector (1).cf6556ae.svg";